module.exports = __webpack_public_path__ + "img/heart.9d1b5424.svg";